import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { X } from "lucide-react"; // or any icon library you use
import CloseIcon from "@mui/icons-material/Close";

toast.configure({
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  CloseIcon: CloseIcon,
  // Responsive toast configuration for web
  style: {
    width: "min(520px, 88vw)",
    minWidth: "200px",
    maxWidth: "90vw",
    height: "auto",
    minHeight: "72px",
    borderRadius: "8px",
    fontSize: "14px",
    lineHeight: "20px",
    padding: "18px 18px",
    margin: "10px auto",
    boxSizing: "border-box",
  },
  closeButton: ({ closeToast }) => (
    <CloseIcon
      onClick={closeToast}
      style={{ cursor: "pointer", color: "#FFFFFF", fontSize: "18px" }}
    />
  ),
});

// Custom wrapper to prevent duplicate toasts
const lastToasts = new Map();

const debouncedToast = {
  ...toast,
  error: (message, options = {}) => {
    const now = Date.now();
    const lastTime = lastToasts.get(message) || 0;

    // Prevent the same message within 4 seconds
    if (now - lastTime > 4000) {
      lastToasts.set(message, now);
      return toast.error(message, options);
    }
    return null;
  },
  success: (message, options = {}) => {
    // Usually success messages don't need debouncing as much, but we can if needed
    return toast.success(message, options);
  }
};

export default debouncedToast;
